import { observable } from "mobx";
import { EntityWithDates } from "./entity";

export class Workflow extends EntityWithDates {
  accountId: number;
  @observable archived: boolean;
  name: string;
}
